import blog1 from "../../assets/blog1.webp";
import blog2 from "../../assets/blog2.webp";
import blog3 from "../../assets/blog3.webp";
import blog4 from "../../assets/blog4.webp";
import blog5 from "../../assets/blog5.webp";
import blog6 from "../../assets/blog6.webp";

const blogData = [
  {
    id: 1,
    img: blog5,
    alt: "A laptop with a sleek design on a modern desk",
    month: "November",
    title: "HOW TO CHOOSE THE PERFECT LAPTOP FOR YOUR NEEDS",
    text: "Discover the key factors to consider when buying a laptop, from performance to portability, tailored to your needs.",
  },
  {
    id: 2,
    img: blog4,
    alt: "A person assembling a custom PC setup",
    month: "October",
    title: "BUILDING YOUR OWN PC: A BEGINNER'S GUIDE",
    text: "Step-by-step guide to building your custom PC: Tips and tricks for assembling your dream setup.",
  },
  {
    id: 3,
    img: blog6,
    alt: "A high-end gaming setup with RGB lighting",
    month: "October",
    title: "TOP GAMING ACCESSORIES FOR THE ULTIMATE EXPERIENCE",
    text: "Explore the best gaming peripherals to elevate your gaming experience, from keyboards to headsets.",
  },
  {
    id: 4,
    img: blog2,
    alt: "A person reviewing a high-performance desktop computer",
    month: "September",
    title: "DESKTOP VS LAPTOP: WHICH IS RIGHT FOR YOU?",
    text: "Understand the pros and cons of desktops and laptops to make the best choice for your work or gaming needs.",
  },
  {
    id: 5,
    img: blog1,
    alt: "A close-up of a high-speed SSD drive",
    month: "September",
    title: "WHY YOU SHOULD UPGRADE TO AN SSD",
    text: "Learn about the benefits of solid-state drives and how they can dramatically improve your computer's performance.",
  },
  {
    id: 6,
    img: blog3,
    alt: "A person exploring smart home devices",
    month: "August",
    title: "SMART HOME TECH: WHERE TO START",
    text: "A beginner's guide to setting up your smart home with the latest tech and gadgets for convenience and security.",
  },
];

export default blogData;
